export default "__VITE_ASSET__9a08e57c__"